export const SET_TOKEN = "SET_TOKEN";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_AVATAR_URL = "SET_AVATAR_URL";
export const SET_IS_DEV = "SET_IS_DEV";